module.exports = __webpack_public_path__ + "img/Gallery_2_25.ea099c6e.jpeg";